import React, { Component } from "react";
import LenderResultRowDetailV2 from "./LenderResultRowDetailV2";
import { validators } from "./Validators";

class LenderResultRowV2Mobile extends Component {
    constructor(props) {
        super(props);
        this.validations = validators();
        this.state = { isDetailExpanded: false, mpUniqueClickID: this.getGUID() ,
            offsetWidth : 0,
        };
        this.handleOfferDetailToggle = this.handleOfferDetailToggle.bind(this);
    }

    // updateDimensions = () => {
    //     var width = document.getElementById('acorn-body');
    //     this.setState({ deviceWidth: width.offsetWidth });   
    // };
    // componentDidMount() {
    //     var width = document.getElementById('acorn-body');
    //     var that = this;
    //     window.addEventListener("resize", (ev) => {
    //         var width = document.getElementById('acorn-body');
    //         that.setState({ deviceWidth : width.offsetWidth});
    //     });
    // }
    // componentWillUnmount() {
    //     window.removeEventListener('resize', this.updateDimensions);
    // }
    handleOfferDetailToggle(event) {
        this.setState((prevState) => ({
            isDetailExpanded: !prevState.isDetailExpanded
        }));
        // if(this.state.isDetailExpanded) {
        //     <i class="fa-solid fa-plus"></i>
        // }
        // else{
        //     <i class="fa-solid fa-minus"></i>
        // }
    }

    componentDidUpdate() {
        // Hiding offer detail on update result clicked if it was opened previously
        if (this.props.isLoading && this.state.isDetailExpanded) {
            this.setState({ isDetailExpanded: false });
        }
    }

    getApplyLinkWithSID() {
        // As lender index is zero based adding 1 on it's value.
        const uuid = typeof window.uuid === typeof undefined ? '' : window.uuid;
        let applyLink = `${this.props.applyLink}${window.prsessionid ? window.prsessionid : ''}&`;
        if(window.AFID && window.AFID !== undefined) {
            var href = new URL(applyLink);
            href.searchParams.set('AFID', `${window.AFID}`);
            applyLink = `${href}&`;
        }
        
        let lenderApplyLink =`${applyLink}SID1=${uuid}&SID2=${this.props.indexCount}-${this.props.loanPurpose}-${this.props.loanAmount/1000}-${this.props.annualIncome/1000}-${this.props.versionLP ? this.props.versionLP : '0'}&SID3=${this.props.creditScore}&SID4=${this.props.currentDevice}&SID5=${this.props.currentBrowser ? this.props.currentBrowser : ''}&SID6=${this.props.SortVersion}&SID7=${this.props.SID7 ? this.props.SID7 : ''}&SID8=${this.props.SID8 ? this.props.SID8 : ''}&SID9=${this.props.SID9 ? this.props.SID9 : ''}&SID10=${this.props.SID10 ? this.props.SID10 : ''}`;
        return  lenderApplyLink;
    }
    parseQueryString = (url) => {
        var urlParams = {};
        url.replace(
            new RegExp("([^?=&]+)(=([^&]*))?", "g"),
            function ($0, $1, $2, $3) {
                urlParams[$1] = $3;
            }
        );
        return urlParams.CID;
    }
    FindTerms(term) {
       if(term !== undefined) {
        var newTerm = term.split(",");
        var min, max =0;
        if(newTerm.length > 0) {
            min = parseInt(newTerm[0], 10) * 12;
        }
        if(newTerm.length > 1) {
            max = parseInt(newTerm[newTerm.length -1 ], 10) * 12;
        }
        return `${min}-${max} Months`;
    }
    return '';
    }
    getGUID() {
        var prGUID = "", i, random;
        for (i = 0; i < 32; i++) {
       random = Math.random() * 16 | 0;
    
       if (i === 8 || i === 12 || i === 16 || i === 20) {
        prGUID += "-"
       }
       prGUID += (i === 12 ? 4 : (i === 16 ? ((random & 3) | 8) : random)).toString(16);
        }
        return prGUID;
      }
    Submit(e){
        if(window._paq) {            
            window._paq.push(['setCustomDimension', window.customDimensionId = 2, window.customDimensionValue = this.props.lender.lender]);
            window._paq.push(['setCustomDimension', window.customDimensionId = 3, window.customDimensionValue = this.state.mpUniqueClickID]);
            window._paq.push(['setCustomDimension', window.customDimensionId = 8, window.customDimensionValue = this.state.mpUniqueClickID]);
            window._paq.push(['setCustomDimension', window.customDimensionId = 9, window.customDimensionValue = this.props.loanAmount]);
            window._paq.push(['setCustomDimension', window.customDimensionId = 10, window.customDimensionValue = this.props.indexCount]);
            window._paq.push(['setCustomDimension', window.customDimensionId = 11, window.customDimensionValue = this.props.creditScore]);
            window._paq.push(['setCustomDimension', window.customDimensionId = 12, window.customDimensionValue = this.props.annualIncome]);
            window._paq.push(['setCustomDimension', window.customDimensionId = 16, window.customDimensionValue = this.props.SortVersion]);
            
            window._paq.push(['trackEvent','PLMP','PLMP Offer Click', this.props.lender.lenderId]);
            var that = this;
            setTimeout(function () {
                that.setState({ mpUniqueClickID: that.getGUID()});
            }, 1000);
        }
    }
    GenerateApplyLink() {
        let lenderApplyLink = `${this.props.applyLink}`;
        if(this.props.lender.partnerId === 16 || this.props.lender.partnerId === 17 
            || this.props.lender.partnerId === 18 || this.props.lender.partnerId === 19 
            || this.props.lender.partnerId === 20 || this.props.lender.partnerId === 21
            || this.props.lender.partnerId === 22){
                lenderApplyLink = `${lenderApplyLink}`;
            } 
            else
             {
                // lenderApplyLink = `${lenderApplyLink}&partnerid=${this.props.lender.partnerId}&featured=1`;
                if(this.props.loanAmountBC) {
                    lenderApplyLink = `${lenderApplyLink}&loanAmount=${this.props.loanAmountBC}`;
                }
                if(this.props.loanPurposeBC) {
                    lenderApplyLink = `${lenderApplyLink}&loanPurpose=${this.props.loanPurposeBC}`;
                }
                if(this.props.gclid) {
                    lenderApplyLink = `${lenderApplyLink}&gclid=${this.props.gclid}`;
                }
                if(this.props.programid) {
                    lenderApplyLink = `${lenderApplyLink}&programid=${this.props.programid}`;
                }
                if(this.props.campaignid) {
                    lenderApplyLink = `${lenderApplyLink}&campaignid=${this.props.campaignid}`;
                }
                if(this.props.utmSource) {
                    lenderApplyLink = `${lenderApplyLink}&utm_source=${this.props.utmSource}`;
                }
                if(this.props.utmMedium) {
                    lenderApplyLink = `${lenderApplyLink}&utm_medium=${this.props.utmMedium}`;
                }
                if(this.props.utmTerm) {
                    lenderApplyLink = `${lenderApplyLink}&utm_term=${this.props.utmTerm}`;
                }
                if(this.props.utmCampaign) {
                    lenderApplyLink = `${lenderApplyLink}&utm_campaign=${this.props.utmCampaign}`;
                }
                if(this.props.utmContent) {
                    lenderApplyLink = `${lenderApplyLink}&utm_content=${this.props.utmContent}`;
                }
                if(this.props.dealerid) {
                    lenderApplyLink="";
                    lenderApplyLink = `${lenderApplyLink}/apply?d=${this.props.dealerid}`;
                }
                if(this.props.version) {
                    lenderApplyLink = `${lenderApplyLink}&version=${this.props.version}`;
                }
            }  
            // lenderApplyLink = lenderApplyLink.replace('[clickid]', this.state.mpUniqueClickID).replace('[affiliateid]',this.props.AffiliateId);
        return  lenderApplyLink;
    }
    render() {
        const lender = this.props.lender;
        const rowClass = '';
        const toggleOfferDetailLabel = this.state.isDetailExpanded ? 'Hide details' : 'View details';
        const lenderPath = lender.lender_image.source_medium;
        const lenderLogo = `https://${window.cdn  !== undefined ? window.cdn : window.location.hostname}${lenderPath}`; 
        const lenderLogoAltText =  lender.lender;
        const minCreditScore = !this.props.IsPRLender ? lender.min_fico_score_text === null ? "None" : lender.min_fico_score_text : '';
        const ctaText = lender.apply.link_text ;        
        const lenderId = lender.lenderId;
        const applyLink = this.GenerateApplyLink();
        const targetBlank = (this.props.lender.partnerId === 16 || this.props.lender.partnerId === 17 
            || this.props.lender.partnerId === 18 || this.props.lender.partnerId === 19 
            || this.props.lender.partnerId === 20 || this.props.lender.partnerId === 21
            || this.props.lender.partnerId === 22) ? '_blank' : '';
        return (
            [
            
            <div className="containerBackground"> 
                
                {/* <a id={'a-' + lenderId} name={'a-' + lenderId} href={applyLink} onClick={this.Submit.bind(this)} target={targetBlank} key={'a-' + lenderId} > */}
                {/* <div className="lender-product-type" key={`ul-${lenderId}`}>{lender.productType}</div> */}
                {/* <div>
                    <div className="lender-product-type" key={`ul-${lenderId}`}>
                    { this.props.showSingleLender !== true && <div className="number">
                    <span className="ribbin-color"><b>{this.props.indexCount}</b> </span>
                    </div>}
                    <div>
                    {lender.productType}</div></div>
                    </div> */}
                    {/* {this.props.deviceWidth <= 767 && */}
                  <div>
                <ul className={`row mobile-lender `} id={lenderId} key={'ul-' + lenderId}>
                 
                    <li className="loan-cellV2 col-xs-12 lender-mobile" key={'li-' + lenderId}>
                        {/* <b className="rank-position">{this.props.indexCount}</b> */}
                        {/* <a href={`#${lenderId}`}
                            key={'li-a-' + lenderId}
                            onClick={this.handleOfferDetailToggle}>
                            
                        </a> */}
                        <div className="col-xs-6">
                        <p>{lender.lenderId}</p>
                        </div>
                        <div className="col-xs-6">
                        <img key={'li-a-img-' + lenderId} id={`id-image-${lenderId}`} name={`name-image-${lenderId}`} alt={lenderLogoAltText} src={lenderLogo} />
                        </div>
                    </li>
                    <li className={` lenderinfoV2 col-xs-12 lender-listing loan-detail-width ${this.props.IsPRLender ? ' pr-content' : '' }`} key={'li-bigtxt-' + lenderId}>
                    {!this.props.IsPRLender  ? <span className="">
                        {/* <div className="Offerdetails">LOAN AMOUNT</div><div className="Offerdetails"><b>Up to <span dangerouslySetInnerHTML={{ __html: `${lender.max_loan_amount_text}` }}></span></b></div><br /> */}
                        {/* { ( this.props.showSingleLender === true ) && <div className={` cta-button-desktop-mid lenderinfoV2 lender-listing cta-btn desktop-down`}>
                                <a href={this.props.ctaBtnLink}><b className={` cta-button desktop`}>{ctaText}</b></a> 
                            </div>
                        } */}
                        <div className="col-xs-6">
                        <span className="Offerdetails"  dangerouslySetInnerHTML={{ __html: `<div class="Offerdetails"><b>${lender.apr_text}</b></div><div>APR </div>` }}></span><br />
                        </div>
                        <div className="col-xs-6"> 
                        <span className="Offerdetails"  dangerouslySetInnerHTML={{ __html: `<div class="Offerdetails"><b>${lender.term_years}</b></div><div>LOAN TERM</div>` }}></span><br />
                        </div>
                        <div>
                        <button type="submit" className="checkOffersButton" id={'select-' } key={'btn1-' + this.props.lenderIndex} onClick={this.sendPostMessageOnSelectOffer} disabled={window.disableClaimOffer}>Check Offers</button>
                        </div>
                        {/* <span className="Offerdetails"><div>Credit Scores </div> <div className="Offerdetails"><b> {minCreditScore.join("/")}</b></div></span>
                            <hr className="filterhr"></hr> */}
                        <span className="show-details" key={'li-span-' + lender.lenderId}>
                            <a key={'li-span-a-' + lender.lenderId} href={`#${lender.lenderId}`} onClick={this.handleOfferDetailToggle}>{toggleOfferDetailLabel}  
                                {this.state.isDetailExpanded ? 
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                        <path d="M18 15l-6-6-6 6" />
                                    </svg>                                                                            
                                : 
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                        <path d="M6 9l6 6 6-6" />
                                    </svg>
                                }
                            </a>                            
                        </span>  
                       
                        {/* <a  id={'btn-' + lenderId} name={'btn-' + lenderId} className={` apply-cta cta-button button-width-full  `} value={ctaText} > </a> */}
                        </span> 
                        : <span>
                            {/* <form action={this.props.IsPRLender ? '/personal-loans/pre-qualify' : this.props.redirectUrl}
                                target="_blank" id={`prloan-from`}
                                method="post"> */}
                                <b className="brand-color"> {lender.title}</b> <br />
                                <p > {lender.description}</p>
                                {/* <b className={`pr-cta-button `}>{ctaText}</b> */}
                                {/* <a id={'btn-' + lenderId} name={'btn-' + lenderId} className={` apply-cta   button-width-full `} value={ctaText} > </a> */}
                                <br />
                            {/* </form> */}
                        </span>
                        }
                    </li> 
                    <li className={` lenderinfoV2 col-xs-7 lender-listing loan-detail-width description ${this.props.IsPRLender ? ' pr-content' : '' }`} key={'li-bigtxt-' + lenderId}>
                        <LenderResultRowDetailV2 key={'detail-' + lender.lenderId}
                        isDetailExpanded={this.state.isDetailExpanded}
                        lender={lender}
                        disclaimer={lender.disclaimer}
                        //lenderDescription={LenderDescriptinData}
                        offerDetail={lender.offers.offer_details.offer_details}
                        rowClass={rowClass}
                        onHideDetailClick={this.handleOfferDetailToggle}
                        toggleOfferDetailLabel={toggleOfferDetailLabel}
                        deviceWidth={this.props.deviceWidth}
                        lenderId={lender.lenderId} />
                    </li>   
                    {/* <li className={` lenderinfoV2 col-xs-7 lender-listing cta-btn loan-detail-width ${this.props.IsPRLender ? ' pr-content' : '' }`} key={'li-bigtxt-' + lenderId}>
                    <b className={` cta-button `}>{ctaText}</b>
                    </li> */}
                </ul> </div> 
            
                    </div>
            ]
        );
    }
}

export default LenderResultRowV2Mobile;


// WEBPACK FOOTER //
// ./src/LenderResultRowV2Mobile.js